import { addressFieldNames } from '../address/addressModule';


export const PAYMENT_FORM_NAME = 'payment';


export const SENDER_EMAIL_FIELD = 'senderEmail';
export const { ADDRESS_COUNTRY } = addressFieldNames;


export const EMAIL_FIELD_MAX = 254;
